import {default as cx} from "classnames"

const JsonEditor = ({
    data,
    onDataChange = () => {},
    maxRows = 5,
    isDataValid = (valid) => {return valid},
}) => {
    const isJSON = (value = data) => {
        try {
            JSON.parse(value)
            return true
        } catch (e) {
            return false
        }
    }

    const formatJson = () => {
        try {
            onDataChange(JSON.stringify(JSON.parse(data), null, 2))
        } catch (e) {
            // ignore invalid JSON
        }
    }

    return (
        <div className="card h-100">
            <div className="card-body d-flex p-0">
                <i
                    className="fas fa-paragraph fs-3 position-absolute bottom-0 end-0 m-4 text-primary"
                    role="button"
                    title={isJSON() ? "Format JSON" : "Unable to format - invalid JSON"}
                    style={{
                        zIndex: 10,
                        cursor: isJSON() ? "pointer" : "not-allowed",
                        opacity: isJSON() ? 1 : 0.5,
                    }}
                    onClick={() => {
                        if (isJSON()) {
                            formatJson()
                        }
                    }}
                />
                <textarea
                    className={cx(
                        "form-control form-control-solid flex-grow-1",
                        isJSON() ? "is-valid" : "is-invalid"
                    )}
                    rows={maxRows}
                    placeholder="Enter configuration JSON"
                    value={data}
                    spellCheck={false}
                    autoComplete="off"
                    autoCorrect="off"
                    autoCapitalize="off"
                    onChange={(evt) => {
                        isDataValid(isJSON(evt.target.value))
                        onDataChange(evt.target.value)
                    }}
                />
            </div>
        </div>
    )
}

export default JsonEditor
